import template from './clientes.html';
import { FormActions } from 'core/services/form';
import clientesI18N from 'i18n/clientes/es.json';
import { fechaRenderer } from 'core/util';
import { formatErrorMessage } from 'core/util';

export let ClientesComponent = {
  templateUrl: template,
  selector: 'clientes',
  bindings: {
    translations: '='
  },
  controller: ClientesCtrl,
  controllerAs: 'vm'
};

const commonsI18N = [
  'Elemento borrado correctamente'
];
export const translationKeys = Object.keys(clientesI18N).concat(commonsI18N);

ClientesCtrl.$inject = [
  'ClientesFactory', '$ngRedux', '$state', 'ngNotify', 'Filter', 'AuthorizationService'
];

function ClientesCtrl(ClientesFactory, $ngRedux, $state, ngNotify, Filter,
  AuthorizationService) {

  Object.assign(this, { $state, $ngRedux, ngNotify });
  var defaultColumnOrder = ['razonSocial', 'sexo.value', 'numeroDocumento', 'tipoDocumento.value', 'email', 'fechaNacimiento'];

  const tiposDocumentoQuery = Filter.path('tipo.codigo').eq('tipo_documento');
  const tiposDocumentoUrl = encodeURI('valores?filter=' + JSON.stringify(tiposDocumentoQuery));

  const tiposPersonaQuery = Filter.path('tipo.codigo').eq('tipo_persona');
  const tiposPersonaUrl = encodeURI('valores?filter=' + JSON.stringify(tiposPersonaQuery));

  const sexoQuery = Filter.path('tipo.codigo').eq('sexo');
  const sexoUrl = encodeURI('valores?filter=' + JSON.stringify(sexoQuery));

  this.options = {
    resource: 'clientes',
    hideHeader: true,
    hasOptions: true,
    title: this.translations['Listado de clientes'],
    factory: ClientesFactory,
    defaultColumnOrder: defaultColumnOrder,
    columns: [
      { data: 'id', title: 'Id' },
      { data: 'activo', title: 'Activo' },
      { data: 'razonSocial', title: this.translations['Razón Social'], defaultContent: '<i>No establecido</i>' },
      {
        data: 'tipoPersona.value',
        title: this.translations['Tipo Persona'],
        type: 'combo',
        filterUrl: tiposPersonaUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.tipoPersona ? row.tipoPersona.name : '<i>No establecido</i>';
        }
      },
      {
        data: 'sexo.value',
        title: this.translations['Sexo'],
        type: 'combo',
        filterUrl: sexoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.sexo ? row.sexo.name : '<i>No establecido</i>';
        }
      },
      { data: 'email', title: this.translations['Email'], defaultContent: '<i>No establecido</i>' },
      {
        data: 'tipoDocumento.value',
        title: this.translations['Tipo Documento'],
        type: 'combo',
        filterUrl: tiposDocumentoUrl,
        idField: 'value',
        textField: 'name',
        keyData: 'data',
        render: function(data, type, row) {
          return row.tipoDocumento ? row.tipoDocumento.name : '<i>No establecido</i>';
        }
      },
      { data: 'numeroDocumento', title: this.translations['Número Documento'], defaultContent: '<i>No establecido</i>' },
      { data: 'fechaNacimiento', title: this.translations['Fecha Nacimiento'], type: 'date-range', renderWith: fechaRenderer }

    ],
    defaultOrderColumn: 0,
    defaultOrderDir: 'desc',
    onEdit: onEdit.bind(this),
    onRemove: onRemove.bind(this),
    onView: onView.bind(this),
    // lo de abajo es lo mismo que hacer
    // canEditCondition: () => AuthorizationService.hasPermission('update_clientes')
    canEditCondition: AuthorizationService.hasPermission.bind(this, 'update_clientes'),
    canRemoveCondition: AuthorizationService.hasPermission.bind(this, 'delete_clientes'),
    canPaqueteCliente: canPaqueteCliente.bind(this),
    extraRowOptions: [
      {
        templateToRender: '<button class="btn-row-datatable btn-row-datatable-extra btn btn-primary btn-dt" uib-tooltip="' + this.translations['Paquetes del cliente'] + '" ng-show="options.canPaqueteCliente(rowsData[<%= dataId %>])" ng-click="paquetesCliente(<%= dataId %>)"> <span class="glyph-icon icon-gift" style="top: -8px;"></span></button>',
        functionName: 'paquetesCliente',
        functionDef: (itemId) => {
          this.$state.go('home.clientes.uid.paquetes-cliente.list', { uid: itemId });
        }
      }
    ]
  };

  function canPaqueteCliente(data) {
    return (data.conPaquetes === 'Sí') && AuthorizationService.hasPermission('index_paquetes');
  }

  this.mapStateToThis = mapStateToThis.bind(this);
  const unsubscribe = $ngRedux.connect(this.mapStateToThis, FormActions)(this);
  this.$onDestroy = () => {
    this.form();
    unsubscribe();
  };

  this.$onInit = () => {
    this.reportOptions = {
      title: this.translations['Listado de clientes']
    };
    this.form();
  };
  this.gotoForm = gotoForm.bind(this);


  function mapStateToThis(state) {

    if (state.form.removed) {
      this.ngNotify.set(this.translations['Elemento borrado correctamente'], 'success');
      this.options.reloadData();
      this.form();
    }

    if (state.form.error) {
      ngNotify.set(formatErrorMessage(state.form.error.message), { type: 'error', html: true });
    }

    return { form: state.form };
  }

  function gotoForm() {
    this.$state.go('home.clientes.new');
  }

  function onEdit(itemId) {
    this.$state.go('home.clientes.uid.edit', { uid: itemId });
  }

  function onRemove(itemId) {
    this.remove('clientes', itemId);
  }

  function onView(itemId) {
    this.$state.go('home.clientes.uid.view', { uid: itemId });
  }
}



// WEBPACK FOOTER //
// ./src/components/clientes/list/clientes.component.js